<script lang="ts" setup>
defineProps<{
  title: string
  description?: string
}>()
</script>

<template>
  <div class="pb-5 mb-5">
    <div class="section-header">
      <h3 class="section-title">{{ title }}</h3>
      <slot name="title-extra" />
    </div>
    <p v-if="description" class="text-sm text-gray-500 mb-3">
      {{ description }}
    </p>
    <slot />
  </div>
</template>

<style scoped lang="scss">
.section-header {
  @apply flex items-center gap-3 mb-4;
}

// section-title has margin-bottom: 16px globally; the wrapper handles spacing here.
// The negative bottom margin cancels its 6px padding + 2px underline border so the
// flex row centers `title-extra` (help icon, links) on the title text, not on the
// box inflated by the underline.
.section-header :deep(.section-title) {
  margin-bottom: -8px;
}
</style>
